import { type GetHookResponse } from '../hooks'
import { videoReportReasonsKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  type VideoReportReasonInput,
  type VideoReportReasonSuccess,
  type VideoId,
  type VideoReportReasonWithUser,
} from '@terros/common'

export function useVideoReportReasons(videoId: VideoId): GetHookResponse<VideoReportReasonWithUser[]> {
  return useTantalimQuery<VideoReportReasonInput, VideoReportReasonSuccess, VideoReportReasonWithUser[]>({
    convertResponse: (data) => data.reasons,
    input: { videoId },
    queryKey: videoReportReasonsKey(videoId),
    url: '/video/report/reason',
  })
}
